export let data = {
  title: "Daftar Rawat Inap",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Daftar Rawat Inap", active: true },
  ],
};
export let dataEdit = {
  title: "Ubah Data Rawat Inap",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Ubah Data Rawat Inap", active: true },
  ],
};
export let today = new Date();
import { getTime } from "./helper.js";
export let time = getTime(today.getHours(), today.getMinutes());
export let leftForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "Tanggal Masuk",
        type: "date",
        placeholder: "Pilih tanggal masuk",
        name: "tgl_masuk",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Jam Masuk",
        type: "time",
        placeholder: "",
        name: "jam_masuk",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Kamar",
        type: "select",
        placeholder: "Pilih Kamar",
        name: "id_kamar",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Cempaka 1",
            value: "C1",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Penanggung Jawab",
        type: "select",
        placeholder: "Pilih Dokter",
        name: "id_dokter",
        value: "",
        mandatory: true,
        multiple: false,
        options: [],
        additional: "",
      },
    ],
  },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Sama dengan dokter rawat jalan",
  //       type: "radio",
  //       placeholder: "",
  //       name: "same_as_ralan",
  //       value: "Tidak",
  //       mandatory: false,
  //       optional:true,
  //       multiple: false,
  //       options: [
  //         {
  //           label: "Ya",
  //           value: "Ya"
  //         },
  //         {
  //           label: "Tidak",
  //           value: "Tidak"
  //         }
  //       ],
  //       additional: ""
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Petugas Penanggung Jawab",
        type: "select",
        placeholder: "Pilih Petugas",
        name: "id_petugas",
        value: "",
        mandatory: true,
        multiple: false,
        options: [],
        additional: "",
      },
    ],
  },
];
export let rightForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Diagnosa awal masuk",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "dgs_awal",
        value: "",
        mandatory: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 3,
    columns: [
      {
        label: "Jumlah",
        type: "addon-right",
        addon: "malam",
        placeholder: "",
        name: "jumlah",
        value: "1",
        defaultValue: "1",
        mandatory: true,
        additional: "",
        colwidth: 4,
      },
      {
        label: "Biaya/malam",
        type: "money",
        placeholder: "",
        name: "satuan",
        value: "0",
        readonly: true,
        mandatory: true,
        additional: "",
        colwidth: 4,
      },
      {
        label: "Total dibayar dimuka",
        type: "money",
        placeholder: "",
        name: "tgh_kamar",
        readonly: true,
        value: "0",
        mandatory: true,
        additional: "",
        colwidth: 4,
      },
    ],
  },
];
export let uploadForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Surat Permintaan Rawat Inap",
        type: "file",
        placeholder: "",
        name: "file_permintaan_ranap",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Pengkajian Awal Pasien Ranap",
        type: "file",
        placeholder: "",
        name: "file_pengkajian_awal",
        value: "",
        mandatory: false,
        optional: true,
      },
      {
        label: "Asesmen Ulang Resiko Jatuh",
        type: "file",
        placeholder: "",
        name: "file_asesmen_resiko",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "SOAP Perawat",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap_perawat",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
      {
        label: "SOAP Dokter",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap_dokter",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Catatan Pemberian Obat",
        type: "file",
        placeholder: "",
        name: "file_catatan_obat",
        value: "",
        mandatory: false,
        optional: true,
      },
      {
        label: "Ringkasan Masuk",
        type: "file",
        placeholder: "",
        name: "file_ringkasan_masuk",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Resume Medis",
        type: "file",
        placeholder: "",
        name: "file_resume_medis",
        value: "",
        mandatory: false,
        optional: true,
      },
      {
        label: "Resume Medis Pasien Pulang",
        type: "file",
        placeholder: "",
        name: "file_resume_pulang",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
];
export let leftFormEdit = [
  {
    colnum: 2,
    columns: [
      {
        label: "Tanggal Masuk",
        type: "date",
        placeholder: "Pilih tanggal masuk",
        name: "tgl_masuk",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Jam Masuk",
        type: "time",
        placeholder: "",
        name: "jam_masuk",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Kamar",
        type: "select",
        placeholder: "Pilih Kamar",
        name: "id_kamar",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Cempaka 1",
            value: "C1",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Penanggung Jawab",
        type: "select",
        placeholder: "Pilih Dokter",
        name: "id_dokter",
        value: "",
        mandatory: true,
        multiple: false,
        options: [],
        additional: "",
      },
    ],
  },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Sama dengan dokter rawat jalan",
  //       type: "radio",
  //       placeholder: "",
  //       name: "same_as_ralan",
  //       value: "Tidak",
  //       mandatory: false,
  //       optional:true,
  //       multiple: false,
  //       options: [
  //         {
  //           label: "Ya",
  //           value: "Ya"
  //         },
  //         {
  //           label: "Tidak",
  //           value: "Tidak"
  //         }
  //       ],
  //       additional: ""
  //     }
  //   ]
  // },
];
export let rightFormEdit = [
  {
    colnum: 1,
    columns: [
      {
        label: "Petugas Penanggung Jawab",
        type: "select",
        placeholder: "Pilih Petugas",
        name: "id_petugas",
        value: "",
        mandatory: true,
        multiple: false,
        options: [],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Diagnosa awal masuk",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "dgs_awal",
        value: "",
        mandatory: true,
        additional: "",
      },
    ],
  },
];
export let uploadFormEdit = [
  {
    colnum: 1,
    columns: [
      {
        label: "Surat Permintaan Rawat Inap",
        type: "file",
        placeholder: "",
        name: "file_permintaan_ranap",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Pengkajian Awal Pasien Ranap",
        type: "file",
        placeholder: "",
        name: "file_pengkajian_awal",
        value: "",
        mandatory: false,
        optional: true,
      },
      {
        label: "Asesmen Ulang Resiko Jatuh",
        type: "file",
        placeholder: "",
        name: "file_asesmen_resiko",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "SOAP Perawat",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap_perawat",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
      {
        label: "SOAP Dokter",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap_dokter",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Catatan Pemberian Obat",
        type: "file",
        placeholder: "",
        name: "file_catatan_obat",
        value: "",
        mandatory: false,
        optional: true,
      },
      {
        label: "Ringkasan Masuk",
        type: "file",
        placeholder: "",
        name: "file_ringkasan_masuk",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Resume Medis",
        type: "file",
        placeholder: "",
        name: "file_resume_medis",
        value: "",
        mandatory: false,
        optional: true,
      },
      {
        label: "Resume Medis Pasien Pulang",
        type: "file",
        placeholder: "",
        name: "file_resume_pulang",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
];

export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6,
      },
    ],
  },
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];
